var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"gift-card",attrs:{"id":"gift-card"}},[_c('div',{staticClass:"gift-card__inner"},[_c('div',{staticClass:"gift-card__text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content.text)}})]),_c('img',{staticClass:"gift-card__image",attrs:{"src":_vm.content.image,"alt":"Carte cadeau"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }